<template>
  <modal @close="close()" title="Генерация White Page">
    <div class="form-create">
      <div class="flex flex-row f-justify-between f-grow-1">
        <div class="form-group">
          <!-- <label>Имя страницы</label> -->
          <input
            type="text"
            class="c-input"
            :class="{ 'is-invalid': formErrors && formErrors.name }"
            v-model="white.name"
            placeholder="Имя страницы"
          />
        </div>
        <div class="form-group">
          <!-- <label>Тема страницы</label> -->
          <c-dropselect
            placeholder="Язык страницы"
            value.sync="white.language"
          ></c-dropselect>
        </div>
        <div class="form-group">
          <!-- <label>Язык страницы</label> -->
          <c-dropselect
            placeholder="Тема страницы"
            value.synv="white.theme"
          ></c-dropselect>
        </div>
      </div>
      <div class="form-col"></div>
    </div>

    <div class="form-create w-100">
      <div class="form-group switches-group form-500 w-100">
        <c-switch :checked.sync="white.custom_post" design="small"
          >Заменить первую статью на свою</c-switch
        >
        <section v-show="white.custom_post">
          <div class="form-group">
            <label>Заголовок первой статьи</label>
            <input type="text" class="c-input" />
          </div>
          <div class="form-group">
            <label>Загрузить изображение для статьи</label>
            <dropzone design="small" update />
          </div>
          <div class="form-group"></div>
          <div class="form-group">
            <label>Текст первой статьи</label>
            <!-- Wysiwyg editor -->
            <page-content-editor
              v-model="white.first_content"
              placeholder="Текст первой статьи"
            />
          </div>
        </section>

        <c-switch :checked.sync="white.advanced_params" design="small"
          >Дополнительные параметры</c-switch
        >
        <section v-show="white.advanced_params">
          <div class="form-group">
            <label>Заголовок страницы</label>
            <input type="text" class="c-input" />
          </div>
          <div class="form-group">
            <label>Логотип</label>
            <input type="text" class="c-input" />
            <!-- Drop Field -->
          </div>
          <div class="form-group">
            <label>Title</label>
            <input type="text" class="c-input" />
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea type="text" class="c-input textarea-resizable" />
          </div>
          <div class="form-create input-280">
            <div class="form-col">
              <div class="form-group">
                <label>Расположение</label>
                <!-- <input type="text" class="c-input" /> -->
                <c-dropselect placeholder="Название статьи" />
                <!-- <select class="c-select c-input">
                  <option value="" disabled>Название статьи</option>
                </select> -->
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label>Значение</label>
                <input type="text" class="c-input" />
              </div>
            </div>
          </div>
        </section>

        <c-switch :checked.sync="white.insert_script" design="small"
          >Вставить свой скрипт <c-tooltip
        /></c-switch>
        <section v-show="white.insert_script">
          <div class="form-group">
            <!-- <label>Script</label> -->
            <textarea
              class="c-input script-insert-input"
              placeholder="Скрипт перед тегом </head>"
            />
          </div>
        </section>
      </div>
    </div>

    <div class="form-submit no-spacing">
      <button
        type="submit"
        class="btn button button-primary large"
        :class="{ disabled: isSaving }"
        @click="submitForm()"
      >
        <div class="loading-spinner white wtext" v-if="isSaving" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          v-else
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.0214 1.01021C15.4401 0.996466 13.9167 1.60435 12.7793 2.70294L12.7689 2.71312L11.04 4.43194C10.6463 4.82333 10.6445 5.45976 11.0359 5.85345C11.4273 6.24713 12.0637 6.24898 12.4574 5.85759L14.1808 4.14417C14.9386 3.41479 15.9521 3.01131 17.004 3.02045C18.0582 3.02961 19.0666 3.45246 19.8121 4.19792C20.5575 4.94338 20.9804 5.95181 20.9895 7.006C20.9987 8.05745 20.5956 9.07053 19.8668 9.82819L16.8578 12.8372L16.8577 12.8373C16.4501 13.245 15.9596 13.5603 15.4194 13.7619C14.8792 13.9634 14.302 14.0463 13.7269 14.0051C13.1519 13.964 12.5924 13.7996 12.0864 13.5232C11.5805 13.2467 11.1399 12.8647 10.7945 12.403C10.462 11.9585 9.83212 11.8677 9.38758 12.2002C8.94305 12.5327 8.85224 13.1627 9.18476 13.6072C9.70276 14.2997 10.3636 14.8727 11.1226 15.2873C11.8815 15.702 12.7207 15.9485 13.5833 16.0103C14.4459 16.0721 15.3117 15.9476 16.122 15.6454C16.9323 15.3431 17.668 14.8702 18.2794 14.2585L21.2948 11.2432L21.307 11.2307C22.4056 10.0933 23.0135 8.56983 22.9998 6.98854C22.986 5.40724 22.3518 3.8946 21.2336 2.77641C20.1154 1.65822 18.6027 1.02395 17.0214 1.01021ZM10.4167 7.98966C9.55406 7.92789 8.68826 8.05235 7.87799 8.3546C7.06778 8.65683 6.33191 9.1299 5.72053 9.74146L2.70518 12.7568L2.69293 12.7693C1.59434 13.9067 0.986456 15.4302 1.0002 17.0115C1.01394 18.5928 1.64821 20.1054 2.7664 21.2236C3.88459 22.3418 5.39723 22.976 6.97853 22.9898C8.55983 23.0035 10.0833 22.3956 11.2207 21.2971L11.2332 21.2848L12.952 19.566C13.3445 19.1734 13.3445 18.537 12.952 18.1445C12.5595 17.7519 11.923 17.7519 11.5305 18.1445L9.81817 19.8568C9.06051 20.5856 8.04744 20.9887 6.996 20.9795C5.9418 20.9704 4.93337 20.5475 4.18791 19.8021C3.44245 19.0566 3.0196 18.0482 3.01044 16.994C3.00131 15.9425 3.40443 14.9295 4.13321 14.1718L7.1423 11.1627C7.5499 10.755 8.04043 10.4396 8.58061 10.2381C9.12079 10.0366 9.69798 9.95366 10.2731 9.99485C10.8481 10.036 11.4076 10.2004 11.9136 10.4768C12.4195 10.7533 12.8601 11.1353 13.2054 11.5969C13.5379 12.0415 14.1679 12.1323 14.6124 11.7998C15.0569 11.4673 15.1477 10.8373 14.8152 10.3928C14.2972 9.70029 13.6363 9.12729 12.8774 8.71265C12.1185 8.29801 11.2793 8.05144 10.4167 7.98966Z"
            fill="#A7B1C0"
          />
        </svg>
        Сгенерировать
      </button>
      <div class="text-danger" v-if="!isFormValid()">Ошибки заполнения формы</div>
      <div class="text-muted white-generate-info">
        Генерация страницы занимает примерно 1 минуту
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import CSwitch from "../Form/switch.vue";
import CDropselect from "../Form/с-dropselect.vue";
import PageContentEditor from "@/components/PageContentEditor.vue";
import Dropzone from "../Dropzone.vue";
import CTooltip from "../Tooltip/c-tooltip.vue";

let Languages = {
  ru: "Русский",
};

let Themes = {
  oil_ai: "Oil ai",
};

let whiteDefault = {
  id: null,
  name: "",
  language: "ru",
  theme: Object.keys(Themes)[0], // First theme of list
  custom_post: false,
  advanced_params: false,
  insert_script: false,
  //
  first_title: "",
  first_content: "",
  first_img: "",
  first_page: "",
  logo: "",
  title: "",
  description: "",
  spacing: null,
  spacing_value: null,
  script: null,
};

export default {
  components: { Modal, CSwitch, PageContentEditor, CDropselect, Dropzone, CTooltip },
  data() {
    return {
      white: Object.assign({}, whiteDefault),
      formErrors: {},
      isSaving: false,
      Languages,
      Themes,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    formValidate() {
      let errors = {};
      let white = this.white;
      if (!white.name) {
        errors.name = "Обязательное поле";
      }

      //
      this.formErrors = errors;
      return Object.getOwnPropertyNames(errors).length - 1 < 1; // -1 because observator
    },
    isFormValid() {
      return Object.getOwnPropertyNames(this.formErrors).length - 1 < 1; // -1 because observator
    },
    resetForm() {
      Object.assign(this.white, whiteDefault);
    },
    submitForm() {
      if (!this.formValidate()) {
        return;
      }
      this.isSaving = true;
      let whiteData = Object.fromEntries(Object.entries(this.white).filter((e) => e[1]));

      this.$apiClient
        .updateWhitepage(this.white.id, whiteData)
        .then((resp) => {
          this.isSaving = false;
          this.resetForm();
          this.close();
          this.$emit("update");
        })
        .catch((err) => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
  max-width: 800px;
}
::v-deep .form-group label {
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 110%;
}

.button svg {
  margin-right: 10px;
}
.white-generate-info {
  margin-top: 20px;
  max-width: 250px;
  line-height: 140%;
  color: #6e7687;

  // &.dark {
  //   color:f
  // }
}
.form-500 {
  max-width: 600px;
}
.switches-group {
  .switch-container {
    margin-bottom: 20px;
  }
}
.w-100 {
  width: 100%;
}
.script-insert-input {
  min-height: 150px;
  resize: both;
  overflow: auto;
}
.c-input {
  width: 100%;
}
.form-group {
  margin-bottom: 40px;

  label {
    margin-bottom: 10px;
  }
}
.form-submit {
  &.no-spacing {
    margin: 0;
  }
}

.form-create .c-input,
.form-create::v-deep .c-select {
  width: 250px;
}
.form-create::v-deep .form-500 .c-input,
.form-create::v-deep .form-500 .c-select {
  width: 100%;
}
.form-create::v-deep .input-280 .c-input,
.form-create::v-deep .input-280 .c-select {
  width: 280px;
}
.form-create::v-deep .toltip-box {
  margin-left: 10px;
}
</style>
